var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShifting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64583 14.5622C3.64583 12.0101 5.47917 9.90592 7.89583 9.44759L6.34375 11.0101L7.8125 12.4788L11.9792 8.30176L7.8125 4.14551L6.34375 5.61426L7.98958 7.26009V7.32259C4.375 7.74967 1.5625 10.833 1.5625 14.5622C1.5625 18.5934 4.82292 21.8538 8.85417 21.8538H11.9792V19.7705H8.85417C5.97917 19.7705 3.64583 17.4372 3.64583 14.5622Z",
    fill: "#ce11d1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 14.5622V21.8538H23.4375V14.5622H14.0625ZM21.3542 19.7705H16.1458V16.6455H21.3542V19.7705Z",
    fill: "#ce11d1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4375 5.18717H14.0625V12.4788H23.4375V5.18717Z",
    fill: "#ce11d1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShifting);
export default __webpack_public_path__ + "static/media/Shifting.6ee862ebf8595c5d434b4b0eae23d78c.svg";
export { ForwardRef as ReactComponent };